import { ButtonHTMLAttributes, isValidElement, ReactNode } from "react";
import RcTooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

export type TooltipPosition =
  | "top"
  | "left"
  | "right"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"
  | "leftTop"
  | "leftBottom"
  | "rightTop"
  | "rightBottom";

interface TooltipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  overlay?: string | ReactNode;
  placement?: TooltipPosition;
  // Where to portal the tooltip DOM. Defaults to document.body, which is
  // invisible behind a <dialog> opened with showModal() (the dialog sits in
  // the browser top layer) — triggers inside a modal should mount the
  // tooltip in the dialog itself, e.g. (node) => node.closest("dialog").
  getTooltipContainer?: (node: HTMLElement) => HTMLElement;
}

export default function Tooltip({
  children,
  overlay,
  placement = "bottom",
  ...props
}: TooltipProps) {
  // Ensure children is a valid React element
  const child = isValidElement(children) ? children : <span>{children}</span>;

  const isHorizontal = placement.startsWith("left") || placement.startsWith("right");

  return (
    <RcTooltip
      overlay={overlay}
      placement={placement}
      mouseEnterDelay={0.5}
      mouseLeaveDelay={0}
      overlayInnerStyle={
        isHorizontal
          ? { marginLeft: "-4px", marginRight: "-4px" }
          : { marginTop: "-4px", marginBottom: "-4px" }
      }
      overlayClassName="max-w-64"
      {...props}
    >
      {child}
    </RcTooltip>
  );
}
